const SMALL_WATERMARK_MAX_SIZE = 24;

// Keep Latin glyphs consistent across Windows and macOS, then use each
// platform's bundled Chinese fonts before falling back to generic families.
const SYSTEM_SANS = 'Arial, "Microsoft YaHei", "PingFang SC", "Segoe UI", sans-serif';
const SYSTEM_SERIF = '"Times New Roman", SimSun, "Songti SC", STSong, serif';

function getWatermarkFontFamily(size) {
  return Number(size) <= SMALL_WATERMARK_MAX_SIZE ? SYSTEM_SANS : SYSTEM_SERIF;
}

export { SMALL_WATERMARK_MAX_SIZE, getWatermarkFontFamily };
